import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "cameraAdd"
const CameraAddIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path d="M5 3h3v2H5v3H3V5H0V3h3V0h2v3ZM12 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6h2a1 1 0 0 0 1-1V3h6l2 2h3.01C21.108 5 22 5.893 22 6.992v11.016c0 1.1-.898 1.992-1.99 1.992H3.99C2.892 20 2 19.107 2 18.008V8Zm15 4.5a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"
          />
        </svg>
      }
    </span>
  )
}
export default CameraAddIcon
